import script from "./PdfPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./PdfPanel.vue?vue&type=script&setup=true&lang=js"

import "./PdfPanel.vue?vue&type=style&index=0&id=5ef5c6b6&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ef5c6b6"]])

export default __exports__